// eslint-disable-next-line
import BMap from 'BMap';

export default {
  data() {
    return {
      map: {},
      address: [], // 地址列表
      origin: '', // 地址
    };
  },
  mounted() {
    this.createMap()
  },
  methods: {
    querySearch(queryString, cb, { Hr: address }) {
      const { restaurants } = this;
      const results = queryString ? address : restaurants;
      cb(results);
    },
    handleSelect({ title, point: { lat, lng } }) {
      this.body.origin = title
      this.body.origin_coordinate.lat = lat
      this.body.origin_coordinate.long = lng
      this.panTo(lat, lng)
    },
    handleSelect2({ title, point: { lat, lng } }) {
      this.body.destination = title
      this.body.destination_coordinate.lat = lat
      this.body.destination_coordinate.long = lng
      this.panTo(lat, lng)
    },
    createStateFilter(queryString) {
      return state => (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    },

    createMap() {
      // 百度地图API功能
      this.map = new BMap.Map('allmap'); // 创建Map实例
      this.map.centerAndZoom(new BMap.Point(114.064552, 22.548456), 12); // 初始化地图,设置中心点坐标和地图级别
      // map.setCurrentCity('北京'); // 设置地图显示的城市 此项是必须设置的
      this.map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
    },
    searchDelivery(queryString, cb) {
      const local = new BMap.LocalSearch(this.map);
      local.search(this.body.origin);
      setTimeout(() => {
        this.querySearch(queryString, cb, local.getResults())
      }, 1000);
    },
    searchDelivery2(queryString, cb) {
      const local = new BMap.LocalSearch(this.map);
      local.search(this.body.destination);
      setTimeout(() => {
        this.querySearch(queryString, cb, local.getResults())
      }, 1000);
    },
    panTo(lat, lng) {
      this.map.panTo(new BMap.Point(lng, lat));
      this.map.setZoom(14);
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuepage/logistics/map.js